/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [真人认证申诉主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=148323548
export const face_verify_homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/face_verify_homepage',
  async (args, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        appeal_record: InitialState['list']
      }>
    >(
      '/live/hiya_socialize/face_verify_homepage',
      {
        ...store.getState().env.deviceinfo,
        type: 1,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [真人认证申诉] http://wiki.xunlei.cn/pages/viewpage.action?pageId=148323775
export const face_verify_appeal = createAsyncThunk(
  'Saada/live/hiya_socialize/face_verify_appeal',
  async (args: Pick<InitialState['list'][0], 'id' | 'type'>, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/face_verify_appeal',
      {
        ...store.getState().env.deviceinfo,
        ...args,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface InitialState {
  list?: Array<{
    id: number
    type: number // 1 真人认证 2头像认证
    status: 0 | 1 // 0 申诉 1 已申诉
    time: string
  }>
}
const initialState: InitialState = {}

export function useCertificationAppeals() {
  return useSelector((store) => store.CertificationAppeals)
}

export const CertificationAppealsSlice = createSlice({
  name: 'CertificationAppeals',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(face_verify_homepage.fulfilled, (state, action) => {
      Object.assign(state, {list: action.payload.appeal_record})
    })
  },
})

export default CertificationAppealsSlice.reducer
export const CertificationAppealsActions = CertificationAppealsSlice.actions
